import { resolveConsent } from "cookiesConsent/features/resolveConsent"
import { GtmConsentSignalFactory } from "cookiesConsent/infrastructure/gtm/GtmConsentSignal"
import { googleTag } from "cookiesConsent/infrastructure/gtm/GoogleTag"
import { persistedC15tConsent } from "cookiesConsent/infrastructure/c15t/consent/persistedC15tConsent"
import { currentJurisdiction } from "cookiesConsent/infrastructure/edgeGeo/currentJurisdiction"
import { currentGeo } from "cookiesConsent/infrastructure/edgeGeo/currentGeo"

export const seedGtmFromVisitor = (): void => {
  const consent = resolveConsent(
    persistedC15tConsent(),
    currentJurisdiction(),
    currentGeo().signal
  )

  googleTag.updateConsent(new GtmConsentSignalFactory().fromConsent(consent))
}
